import { AUTH_ENDPOINTS, API_URL } from '../constants';
import { jwtDecode } from 'jwt-decode';
import { authCookies } from './cookies';
import axios from 'axios';

export const auth = {
    getIdToken: () => authCookies.getIdToken(),
    getAccessToken: () => authCookies.getAccessToken(),
    getRefreshToken: () => authCookies.getRefreshToken(),
    isAuthenticated: () => authCookies.isAuthenticated(),
    clearTokens: () => {
        authCookies.clearTokens();
    },
    getCognitoLoginUrl: () => AUTH_ENDPOINTS.getCognitoLoginUrl(),
    isTokenExpired: (token) => {
        if (!token) return true;
        try {
            const decoded = jwtDecode(token);
            if (!decoded || !decoded.exp) return true;
            const bufferTime = 5 * 60;
            return decoded.exp < (Date.now() / 1000) + bufferTime;
        } catch (error) {
            console.error('Error decoding token:', error);
            return true;
        }
    },
    
    isTokenFromOldSession: (token) => {
        if (!token) return true;
        try {
            const decoded = jwtDecode(token);
            if (!decoded || !decoded.iat) return true;
            
            const tokenAge = Date.now() / 1000 - decoded.iat;
            const maxTokenAge = 24 * 60 * 60;
            
            return tokenAge > maxTokenAge;
        } catch (error) {
            console.error('Error decoding token age:', error);
            return true;
        }
    },
    getValidToken: async () => {
        const idToken = authCookies.getIdToken();
        if (!idToken || auth.isTokenExpired(idToken) || auth.isTokenFromOldSession(idToken)) {
            console.log('Token expired, expiring soon, or from old session, attempting refresh...');
            const refreshSuccess = await auth.refreshToken();
            if (refreshSuccess) {
                return authCookies.getIdToken();
            } else {
                console.log('Token refresh failed, returning null');
                return null;
            }
        }
        return idToken;
    },
    refreshToken: async () => {
        const refreshToken = authCookies.getRefreshToken();
        if (!refreshToken) return false;
        try {
            const response = await axios.get(`${API_URL}/auth/refresh?refresh_token=${refreshToken}`);
            if (response.data.error) throw new Error(response.data.error);
            if (response.data.id_token) authCookies.setIdToken(response.data.id_token);
            if (response.data.access_token) authCookies.setAccessToken(response.data.access_token);
            if (response.data.refresh_token) authCookies.setRefreshToken(response.data.refresh_token);
            return true;
        } catch (error) {
            console.error('Error refreshing token:', error);
            return false;
        }
    }
}; 